import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import ReturnReceive from 'components/Return/ReturnReceive';
// eslint-disable-next-line
export default () => {
  return (
    <ContentLayout>
      <SiteContent>
        {/*<h1>Warehouse</h1>*/}
        <ReturnReceive />
      </SiteContent>
    </ContentLayout>
  );
};
